if (process.env.REACT_APP_USE_MOCK_API) {
  module.exports = require("./settingsApiMock");
} else {
  module.exports = require("./settingsApi");
}
